






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { IEmployment } from "@/dto/payroll/IEmployment";
import { EmploymentFilter } from "@/dto/payroll/Filters";
import EmploymentService from "@/services/EmploymentService";
import PolicyService from "@/services/payroll/PolicyService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import { EmploymentStatus } from "@/components/payroll/business/employments/contractors/Contractor";
import {CounterpartyType} from "@/constants/CounterpartyType";

@Component
export default class PTOAttachEmploymentsModal extends Vue {
	@Prop({ required: true })
	private policyId!: number;

	@Prop({ required: true })
	private companyId!: number;

	@Prop({ required: true })
	private callback!: () => void;

	@Prop({ default: () => [] })
	private assignedEmploymentIds!: number[];

	private employments: IEmployment[] = [];
	private loading = true;
	private submitting = false;
	private selectedIds: number[] = [];

	private get assignedIds(): Set<number> {
		return new Set(this.assignedEmploymentIds);
	}

	private get attachableEmployments(): IEmployment[] {
		return this.employments.filter(e => e.id != null);
	}

	public mounted(): void {
		const filter = new EmploymentFilter({
			employerId: this.companyId,
			types: ["STAFF", "FOREIGN"],
			contractorType: CounterpartyType.PERSON,
			status: [EmploymentStatus.NEW, EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS],
			pageSize: 200,
			pageNumber: 0
		});
		EmploymentService.getPageByFilter<IEmployment>(filter).then(
			res => {
				this.employments = res.data.data || [];
				this.loading = false;
			},
			err => {
				processError(err, this);
				this.loading = false;
			}
		);
	}

	private employmentDisplayName(emp: IEmployment): string {
		if (emp.details && emp.details.name) return emp.details.name;
		return `#${emp.id}`;
	}

	private toggle(id: number): void {
		const i = this.selectedIds.indexOf(id);
		if (i >= 0) {
			this.selectedIds = this.selectedIds.slice(0, i).concat(this.selectedIds.slice(i + 1));
		} else {
			this.selectedIds = this.selectedIds.concat(id);
		}
	}

	private selectAll(): void {
		this.selectedIds = this.attachableEmployments
			.map(e => e.id as number)
			.filter(id => !this.assignedIds.has(id));
	}

	private deselectAll(): void {
		this.selectedIds = [];
	}

	private attachSelected(): void {
		if (this.selectedIds.length === 0) return;
		this.submitting = true;
		Application.startLoading();
		PolicyService.attachPTOEmployments(this.policyId, this.selectedIds).then(
			() => {
				Application.stopLoading();
				this.submitting = false;
				this.$modal.hideAll();
				this.callback();
			},
			err => {
				processError(err, this);
				Application.stopLoading();
				this.submitting = false;
			}
		);
	}
}
